import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Login.module.css';
import Footer from '../../Components/Footer/Footer';

import { signIn } from '../../firebase/auth';
import { useFacility } from '../../context/FacilityContext';
import { HelmetProvider } from 'react-helmet-async';

function Login() {
  let navigate = useNavigate();

  const { _, setFacilityId } = useFacility();

  const [staffEmail, setStaffEmail] = useState('');
  const [staffPassword, setStaffPassword] = useState('');

  const handleSignIn = async (e) => {
    e.preventDefault();
    try {
      const user = await signIn(staffEmail, staffPassword);
      //setFacilityId(facilityId);
      navigate('/verify');
    } catch (error) {
      alert('Incorrect email or password!');
    }
  };
  return (
    <>
      <HelmetProvider>
        <title>Centara Care</title>
        <meta name="twitter:title" content="Centara Care" />
        <meta property="og:title" content="Centara Care" />
        <meta
          name="description"
          content="Centara is an all-in-one central resident portal designed to empower nursing home communities with superior care, connection, and convenience through innovative technology."
        />
        <meta
          property="og:description"
          content="Centara is an all-in-one central resident portal designed to empower nursing home communities with superior care, connection, and convenience through innovative technology."
        />
        <meta
          name="twitter:description"
          content="Centara is an all-in-one central resident portal designed to empower nursing home communities with superior care, connection, and convenience through innovative technology."
        />
      </HelmetProvider>
      <div className={styles.loginContainer}>
        <div className={styles.staffLoginContainer}>
          <h3>Login</h3>
          <form onSubmit={handleSignIn}>
            <input
              type="email"
              value={staffEmail}
              onChange={(e) => setStaffEmail(e.target.value)}
              placeholder="Email"
              autoComplete="email"
              required
            />
            <input
              type="password"
              value={staffPassword}
              onChange={(e) => setStaffPassword(e.target.value)}
              placeholder="Password"
              autoComplete="password"
              required
            />
            <button type="submit">Sign In</button>
          </form>
        </div>
      </div>
      <Footer />
    </>
  );
}
export default Login;
